import script from "./EditField.vue?vue&type=script&setup=true&lang=js"
export * from "./EditField.vue?vue&type=script&setup=true&lang=js"

import "./EditField.vue?vue&type=style&index=0&id=b9372548&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9372548"]])

export default __exports__